import script from "./RatingSkillsTableWeb.vue?vue&type=script&setup=true&lang=js"
export * from "./RatingSkillsTableWeb.vue?vue&type=script&setup=true&lang=js"

import "./RatingSkillsTableWeb.vue?vue&type=style&index=0&id=2b6af86e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b6af86e"]])

export default __exports__